import { adminHttpClient } from '../../commons/adminHttpClient'
import { Product } from 'domain/product/Product'
import { BenefitDesignStatus } from '../../../domain/benefit/benefitDesignStatus'
import { NamedItem } from '../../../domain/common/namedItem'

export interface CompanyInfoDetails {
  companyDetails: CompanyInfo
  benefits: BenefitDetails[]
}

export interface CompanyInfo {
  id: string
  name: string
  productTypeId: Product
  createdAt: string
  endedOn: string
  recurlyCustomerUrl: string
  salesforceCustomerUrl: string
  numberOfEmployees: number
  products: ProductResponse[]
}

export type ProductResponse = NamedItem & {
  minimumSeats: number
  chargeIneligibleAdmins: boolean
}

export interface BenefitDetails {
  id: string
  startDate: string
  endDate: string
  benefitDesignStatus: BenefitDesignStatus
  productTypeId: Product
  active: boolean
}

const getCompanyInfo = (companyId: string): Promise<CompanyInfoDetails> => {
  return adminHttpClient.get(`/csi/Companies/generaldetails/${companyId}`)
}

export default getCompanyInfo
